import React, { useState } from 'react'
import './Menu.css'
import { useNavigate, NavLink } from 'react-router-dom'
import {   ARTICLES ,ASSET_MANAGEMENT ,ALLCATERGORIES, ESCALATION_RULE_LOG, ERROR_LOG ,EMAIL_EXECUTION ,ALARM_PAGE, ADMIN_GROUP ,MYPACK, TEAMPACK, DASHBOARD, COMPANY, DIVISION, REGION, MARKET, STORES, EMPLOYEES, ACQUISITION, DENSITY, STORECLASSIFICATION, COMPGROUP, CTYPE, REGIONTRACKER, STOREHOURS, JOB_TITLE, EMPLOYEE_TYPE, EMPLOYEE_LEAVE_TYPE, EMPLOYEE_DEPARTMENT, EMPLOYEE_STATUS, HIRE_STATUS, TERM_REASON, PART_FULL_TIME, HOURLY_SALARY, STORETRACKER, DENSITYTRACKER, STORECLASSIFICATIONTRACKER, COMMCOMPTRACKER, DESIGNATION_TRACKER, EMP_TYPE_HIRE_STATUS_TRACKER, ROLES, GROUPS, MODULEMETADATA, EMPLOYEE_ROLE_MAPPING, ROLE_MODULE_MAPPING, ODOO_STORE_TRANSFER_TRACKERS, ODOO_DESIGNATION_TRACKERS, KEY_TAG, EMPLOYEETABLES, STORETABLES, FORM_BULK_IMPORT, CHATGROUPS, DEFAULTGROUPS, TICKET, TICKETING,ESCALATION_RULES, QUESTIONLIST, MESSAGE_TEMPLATES_LIST, SEAT_BOOKING, EMAIL_RULE, EMAIL_RULE_LIST, CATEGORIES } from '../../shared/constants/Constants';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import { Col, Dropdown, Row } from 'react-bootstrap'
import MenuCollapsableItem from './MenuCollapsableItem'
import Permissions from '../../shared/components/Permissions';

const MenuCollapsed = () => {
    let navigate = useNavigate()
    let logoPath = "/mark-dark.png";

    let empInfo = JSON.parse(localStorage.getItem('employee'));
    let emp_company = localStorage.getItem('emp_company');
    let securityTab = false;
    if (empInfo?.role === "admin") {
        securityTab = true;
    }

    let emp_no = JSON.parse(localStorage.getItem("emp_no"));
    let module_name = "VMO";
    let vmoPermission = Permissions(emp_no, module_name);
    let BIPermission = Permissions(emp_no, 'Power BI Security');
    let chatAuditPermission = Permissions(emp_no, 'Chat Audit');
    let NotificationPermission = Permissions(emp_no, 'Notification Audit');
    const isAdmin = empInfo?.role === "admin";
    const ticketemployees = [ "134321","105729"];
    const hasTicketAccess =  isAdmin || ticketemployees.includes(String(emp_no));
    const seatReservation = Permissions(emp_no, 'Seat Reservation');
    const AdminGroupPermission = Permissions(emp_no, 'Admin Group');


    return (
        <div className="sidebar-wrapper d-none-sm">
            <div className="sidebar-header">
                <div>
                    <img src={logoPath} alt="logo icon" className='company-logo-col' />
                </div>
            </div>
            <div id="menu-spacer" style={{ height: '45px' }}></div>
            <div className="sidebar-body" style={{ overflow: 'visible' }}>
                <ul id="menu">
                    {(emp_company === "Operis") ? (<>
                        <SubMenu
                            icon={<i className='fa fa-couch' onClick={() => navigate('/seatbooking')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/seatbooking')}>{SEAT_BOOKING}</Dropdown.Item>
                                </>
                            }
                        />
                    </>) : (empInfo?.role === "hc_sales") ? (<>
                        <SubMenu
                            icon={<i className='fa fa-user-o' onClick={() => navigate('/userProfile')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/userProfile')}>Profile</Dropdown.Item>
                                </>
                            }
                        /> 
                        <SubMenu
                            icon={<i className='fa fa-circle-info' onClick={() => navigate('/t-shirtSize')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/t-shirtSize')}>Additional Info</Dropdown.Item>
                                </>
                            }
                        /> 
                        <SubMenu
                            icon={<i className='fa fa-tasks' onClick={() => navigate('/myplan?filter=none')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/myplan?filter=none')}>My Plan</Dropdown.Item>
                                </>
                            }
                        /> 
                        <SubMenu
                            icon={<i className='fa fa-group' onClick={() => navigate('/teamplan?filter=none')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/teamplan?filter=none')}> Team Plan</Dropdown.Item>
                                </>
                            }
                        /> 
                        <SubMenu
                            icon={<i className='fa fa-comment' onClick={() => navigate('/defaultgroups?filter=none')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/defaultgroups?filter=none')}> Broadcast Groups</Dropdown.Item>
                                </>
                            }
                        />

                            { seatReservation.create_permission  ? (
                        <SubMenu
                                icon={<i className='fa fa-couch' onClick={() => navigate('/seatbooking')}></i>}
                                children={
                                    <>
                                        <Dropdown.Item className="header" as={NavLink} to={('/seatbooking')}>{SEAT_BOOKING}</Dropdown.Item>
                                    </>
                                }
                        />
                        ) : (<></> )}    
                            
                        
                    </>) : (<>

                    <SubMenu
                        icon={<i className='fa fa-home' onClick={() => navigate('/dashboard')}></i>}
                        children={
                            <>
                                <Dropdown.Item className="header" as={NavLink} to={('/dashboard')}>{DASHBOARD}</Dropdown.Item>
                            </>
                        }

                    />
                    <SubMenu
                            icon={<i className='fa fa-couch' onClick={() => navigate('/seatbooking')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/seatbooking')}>{SEAT_BOOKING}</Dropdown.Item>
                                </>
                            }
                    />                    
                    <SubMenu
                        icon={<i className='fa fa-headset'></i>}
                        width={240}
                        children={
                            <>
                                <Dropdown.Item className="header">Vision Hub</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/ticketing?filter=none'}><i className="fa fa-ticket me-2"></i>{TICKETING}</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/messageTemplatesList?filter=none'}><i className="fa fa-envelope-open-text me-2"></i>{MESSAGE_TEMPLATES_LIST}</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/articles?filter=none'}><i className="fa fa-newspaper-o me-2"></i>{ARTICLES}</Dropdown.Item>

                                {hasTicketAccess ? (
                                    <MenuCollapsableItem hasLeftArrow={true} parent={
                                        <div className="sub-menu-title me-3">Settings</div>
                                    }>
                                        <Dropdown.Item as={NavLink} to={'/allcategories?filter=none'}><i className="fa fa-list me-2"></i>{ALLCATERGORIES}</Dropdown.Item>
                                        <Dropdown.Item as={NavLink} to={'/categories?filter=none'}><i className="fa fa-sliders me-2"></i>Category Configs</Dropdown.Item>
                                        <Dropdown.Item as={NavLink} to={'/escalationRules'}><i className="fa fa-exclamation-triangle me-2"></i>{ESCALATION_RULES}</Dropdown.Item>
                                        <Dropdown.Item as={NavLink} to={'/questionlist'}><i className="fa fa-question-circle me-2"></i>{QUESTIONLIST}</Dropdown.Item>
                                        <Dropdown.Item as={NavLink} to={'/emailrulelist'}><i className="fa fa-envelope me-2"></i>{EMAIL_RULE_LIST}</Dropdown.Item>
                                        <Dropdown.Item as={NavLink} to={'/ticket-email-execution?filter=none'}><i className="fa fa-paper-plane me-2"></i>{EMAIL_EXECUTION}</Dropdown.Item>
                                        <Dropdown.Item as={NavLink} to={'/ticket-escalationrule-log?filter=none'}><i className="fa fa-history me-2"></i>{ESCALATION_RULE_LOG}</Dropdown.Item>
                                    </MenuCollapsableItem>
                                ) : null}
                            </>
                        }
                    />
                    {/* <SubMenu
                        icon={<i className='fa fa-ticket' onClick={() => navigate('/ticketing?filter=none')}></i>}
                        children={
                            <>
                                <Dropdown.Item className="header" as={NavLink} to={('/ticketing?filter=none')}>{TICKETING}</Dropdown.Item>
                            </>
                        }
                    />         

                     <SubMenu
                        icon={<i className='fas fa-envelope-open-text' onClick={() => navigate('/messageTemplatesList?filter=none')}></i>}
                        children={
                            <>
                                <Dropdown.Item className="header" as={NavLink} to={('/messageTemplatesList?filter=none')}>{MESSAGE_TEMPLATES_LIST}</Dropdown.Item>
                            </>
                        }
                    />                   
                      */}
                  
                        {/* {hasTicketAccess ? (  */}
                    {/* <SubMenu
                            icon={<i className='fas fa-gear'></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header">Vision Hub Settings</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={('/categories?filter=none')}>Categories</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={('/escalationRules')}>{ESCALATION_RULES}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={('/questionlist')}>{QUESTIONLIST}</Dropdown.Item>    
                                    <Dropdown.Item as={NavLink} to={('/messageTemplatesList')}>{MESSAGE_TEMPLATES_LIST}</Dropdown.Item>                                              
                                </>
                            }
                        />
                         ) : (<></>) */}
                    <SubMenu
                        icon={<i className='fa fa-map'></i>}
                        width={240}
                        children={
                            <>
                                <Dropdown.Item className="header">Org. Hierarchy</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/company?status=active'}><i className="fa fa-building me-2"></i>{COMPANY}</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/division?status=active'}><i className="fa fa-sitemap me-2"></i>{DIVISION}</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/region?status=active'}><i className="fa fa-globe me-2"></i>{REGION}</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/district?status=active'}><i className="fa fa-map-marker me-2"></i>{MARKET}</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/stores'}><i className="fa fa-store me-2"></i>{STORES}</Dropdown.Item>
                                <MenuCollapsableItem hasLeftArrow={true} parent={
                                    <div className="sub-menu-title me-3">{STORETABLES}</div>
                                }>
                                    <Dropdown.Item as={NavLink} to={'/channel-type?filter=none'}><i className="fa fa-random me-2"></i>{CTYPE}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/store-classification?filter=none'}><i className="fa fa-tags me-2"></i>{STORECLASSIFICATION}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/density?filter=none'}><i className="fa fa-th me-2"></i>{DENSITY}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/acquisition?filter=none'}><i className="fa fa-handshake me-2"></i>{ACQUISITION}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/commission-comp-group?filter=none'}><i className="fa fa-percent me-2"></i>{COMPGROUP}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/store-hours?filter=none'}><i className="fa fa-clock me-2"></i>{STOREHOURS}</Dropdown.Item>
                                </MenuCollapsableItem>
                            </>
                        }
                    />
                    <SubMenu
                        icon={<i className='fa fa-users'></i>}
                        children={
                            <>
                                <Dropdown.Item className="header">{EMPLOYEES}</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/employees'}><i className="fa fa-user me-2"></i>{EMPLOYEES}</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/all-tshirtsizes'}><i className="fa fa-id-card me-2"></i>Employee Additional Info</Dropdown.Item>
                                {isAdmin || AdminGroupPermission?.create_permission ? (
                                    <Dropdown.Item as={NavLink} to={'/admingroup'}><i className="fa fa-users-cog me-2"></i>{ADMIN_GROUP}</Dropdown.Item>
                                ) : null}
                                {securityTab ? (
                                <MenuCollapsableItem hasLeftArrow={true} parent={
                                    <div className="sub-menu-title me-3">{EMPLOYEETABLES}</div>
                                }>
                                    <Dropdown.Item as={NavLink} to={'/departments?filter=none'}><i className="fa fa-building me-2"></i>{EMPLOYEE_DEPARTMENT}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/leave-types?filter=none'}><i className="fa fa-plane me-2"></i>{EMPLOYEE_LEAVE_TYPE}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/employee-types?filter=none'}><i className="fa fa-user-tag me-2"></i>{EMPLOYEE_TYPE}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/jobtitles?filter=none'}><i className="fa fa-briefcase me-2"></i>{JOB_TITLE}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/employee-status?filter=none'}><i className="fa fa-toggle-on me-2"></i>{EMPLOYEE_STATUS}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/hire-status?filter=none'}><i className="fa fa-user-plus me-2"></i>{HIRE_STATUS}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/term-reason?filter=none'}><i className="fa fa-user-times me-2"></i>{TERM_REASON}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/full-part-time?filter=none'}><i className="fa fa-clock me-2"></i>{PART_FULL_TIME}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/hourly-salary?filter=none'}><i className="fa fa-money-bill me-2"></i>{HOURLY_SALARY}</Dropdown.Item>
                                </MenuCollapsableItem>) : (<></>)}
                            </>
                        }
                    />
                    <SubMenu
                            icon={<i className='fa fa-bullhorn' onClick={() => navigate('/alarmpage?filter={"status":{"filterType":"text","type":"inArray","filter":["pending"]}}')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/alarmpage?filter={"status":{"filterType":"text","type":"inArray","filter":["pending"]}}')}>{ALARM_PAGE}</Dropdown.Item>
                                </>
                            }
                    />   

                    <SubMenu
                        icon={<i className='fa fa-cube' onClick={() => navigate('/asset-management')}></i>}
                        children={
                            <>
                                <Dropdown.Item className="header">Asset Management</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/asset-management'}><i className="fa fa-cube me-2"></i>{ASSET_MANAGEMENT}</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/asset-management-form'}><i className="fa fa-file-alt me-2"></i>Asset FormList</Dropdown.Item>
                            </>
                        }
                    />

                    {securityTab ? (
                        <SubMenu
                            icon={<i className='fas fa-shield'></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header">Security</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={"/roles?filter=none"}>{ROLES}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/groups?filter=none'}>{GROUPS}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/module-meta-data?filter=none'}>{MODULEMETADATA}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/role-module-mapping?filter=none'}>{ROLE_MODULE_MAPPING}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/employee-role-mapping?filter=none'}>{EMPLOYEE_ROLE_MAPPING}</Dropdown.Item>

                                </>
                            }
                        />
                    ) : (<></>)}
                    {/* {securityTab ? ( */}
                        {/* <SubMenu
                            icon={<i className='fas fa-dot-circle'></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header">Odoo</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/odoo-store-transfer-trackers?filter=none'}>{ODOO_STORE_TRANSFER_TRACKERS}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/odoo-designation-trackers?filter=none'}>{ODOO_DESIGNATION_TRACKERS}</Dropdown.Item>
                                </>
                            }
                        /> */}
                    {/* ) : (<></>)}  */}
                    {securityTab ? (
                        <SubMenu
                            icon={<i className='fa fa-tags' onClick={() => navigate('/admin-key-tag?filter=none')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/admin-key-tag?filter=none')}>{KEY_TAG}</Dropdown.Item>
                                </>
                            }
                        />
                       ) : (<></>)}
                        {/* <SubMenu
                            icon={<i className='fa fa-list-alt' onClick={() => navigate('/form-bulk-import?filter=none')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/form-bulk-import?filter=none')}>{FORM_BULK_IMPORT}</Dropdown.Item>
                                </>
                            }
                        /> */}
                    {/* ) : (<></>)} */}
                    {securityTab ? ( 
                        <SubMenu
                            icon={<i className='fa fa-history'></i>}
                            width={270}
                            children={
                                <>
                                    <Dropdown.Item className="header">Trackers</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/region-tracker?filter=none'}>{REGIONTRACKER}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/district-tracker?filter=none'}>District Tracker</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/store-tracker?filter=none'}>{STORETRACKER}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/densityclass-tracker?filter=none'}>{DENSITYTRACKER}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/commcomp-tracker?filter=none'}>{COMMCOMPTRACKER}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/store-classification-tracker?filter=none'}>{STORECLASSIFICATIONTRACKER}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/designation-tracker?filter=none'}>{DESIGNATION_TRACKER}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/emptype-hirestatus-tracker?filter=none'}>{EMP_TYPE_HIRE_STATUS_TRACKER}</Dropdown.Item>
                                    
                                </>
                            }
                        />
                   ) : (<></>)}
                    {/*  {securityTab ? ( */}
                        <SubMenu
                            icon={<i className='fa fa-clipboard-list'></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header">Audits</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/queue-table?filter=none'}>{"Workflow Queue"}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/audit?filter=none'}>{"Audit Logs"}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/HireTermQueue?filter=none'}>Hire Term Queue</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/ticketerrorlog?filter=none'}>{ERROR_LOG}</Dropdown.Item>   
   
                                </>
                            }
                        />
                    {/* ) : (<></>)} */}
                    <SubMenu
                        icon={<i className='fa fa-shopping-cart'></i>}
                        children={
                            <>
                                <Dropdown.Item className="header">Product</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/products'}>Products</Dropdown.Item>
                                <Dropdown.Item as={NavLink} to={'/product-tables'}>Product Tables</Dropdown.Item>
                                {/* <MenuCollapsableItem hasLeftArrow={true} parent={
                                    <div className="sub-menu-title me-3">Product Tables</div>
                                } className="last-child">
                                    <Dropdown.Item as={NavLink} to={'/product-type?filter=none'}>Product Type</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/accessories?filter=none'}>Accessories</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/account-type?filter=none'}>Account Type</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/category?filter=none'}>Category</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/category-product?filter=none'}>Category Product</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/line-type?filter=none'}>Line Type</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/relationship-type?filter=none'}>Relationship Type</Dropdown.Item>
                                </MenuCollapsableItem> */}
                            </>
                        }
                    />
                        <SubMenu
                            icon={<i className='fa fa-comment'></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header">Chat</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/chatgroups?filter=none'}>{"Groups"}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/defaultgroups?filter=none'}>{"Broadcast Groups"}</Dropdown.Item>
                                    {chatAuditPermission?.create_permission ? (
                                        <Dropdown.Item as={NavLink} to={'/auditmessages?filter=none'}>{"Audit Messages"}</Dropdown.Item>
                                    ) : null}
                                </>
                            }
                        />
                        <SubMenu
                            icon={<i className='fa fa-bell'></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header">Notification</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={('/notification?filter=none')}>Notifications</Dropdown.Item>
                                    {NotificationPermission?.create_permission ? (
                                    <Dropdown.Item as={NavLink} to={('/notification/Audits?filter=none')}>Audit Notifications</Dropdown.Item>
                                      ) : null}
                                </>
                            }
                        />
                        {vmoPermission.write_permission ? (<>
                        <SubMenu
                            icon={<i className='fa fa-pencil-square-o'></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header">VMO</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/quarterlyReview?filter=none'}>{"Quarterly Review"}</Dropdown.Item>
                                    <Dropdown.Item as={NavLink} to={'/retail-foundation?filter=none'}>{"Retail Foundation"}</Dropdown.Item> 
                                </>
                            }
                        />
                        </>) : (<></>)}
                        
                        <SubMenu
                            icon={<i className='fa fa-store' onClick={() => navigate('/search-sap?filter=none')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/search-sap?filter=none')}>Search SAP</Dropdown.Item>
                                    <Dropdown.Item className="header" as={NavLink} to={('/storevisit?filter=none')}>Store Visit List</Dropdown.Item>
                                </>
                            }
                        />
                        <SubMenu
                            icon={<i className='fa fa-file' onClick={() => navigate('/allplan?filter=none')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/allplan?filter=none')}>All Priority Plans</Dropdown.Item>
                                </>
                            }
                        />
                        {BIPermission?.create_permission ? (
                        <SubMenu
                            icon={<i className='fa fa-chart-bar' onClick={() => navigate('/powerbi-security')}></i>}
                            children={
                                <>
                                    <Dropdown.Item className="header" as={NavLink} to={('/powerbi-security')}>Power BI Security</Dropdown.Item>

                                </>
                            }
                        />
                        ) : (<></>)}


                    </>)}
                </ul>
            </div>
        </div>
    )
}

export default MenuCollapsed

function SubMenu({ icon, children, width }) {
    let [show, setShow] = useState(false)

    let list
    if (children) {
        list = <DropdownMenu show={show} style={{ marginLeft: 55, marginTop: '-44px', padding: 0, width: width??230 }}>
            {children}
        </DropdownMenu>
    }
    return < Row onMouseEnter={() => { setShow(true) }} onMouseLeave={() => { setShow(false) }}>
        <Col>
            <div className={"collapsed-menu-parent-icon" + (show ? " hovered" : '')} >{icon}</div>
            {list}
        </Col>
    </Row >
}